const formFactoryEn = {
  collectionToggle: {
    skipInput: 'Skip input'
  },
  defaultErrorComponent: {
    title: 'Input errors:'
  },
  dynamicSelectField: {
    error: {
      loading: 'Error loading options',
      loadingDescription: 'Please try again later',
      selectDependencyFirst: 'Please select a dependency field first'
    }
  },
  fileField: {
    maxFileSize: 'Max {{size}}MB per file',
    maxFiles: 'Max {{count}} files',
    noFilesSelected: 'No files selected',
    supportedFormats: 'Supported formats: {{formats}}'
  },
  licenseSelectField: {
    loading: 'Loading licenses...',
    noLicensesAvailable: 'No licenses available',
    selectLicense: 'Select a license',
    selectSoftwareFirst: 'Please select software first'
  },
  multiSelectCheckboxField: {
    noOptionsAvailable: 'No options available'
  },
  progressLabels: {
    progress: 'Progress',
    required: 'Required'
  },
  softwareSelectField: {
    noSoftwareFound: 'No available software found'
  }
};
export default formFactoryEn;